import { render, staticRenderFns } from "./bannerTap.vue?vue&type=template&id=4d1dac14&scoped=true&"
import script from "./bannerTap.vue?vue&type=script&lang=js&"
export * from "./bannerTap.vue?vue&type=script&lang=js&"
import style0 from "./bannerTap.vue?vue&type=style&index=0&id=4d1dac14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1dac14",
  null
  
)

export default component.exports